import { COOKIE_KEYS, storageKeys } from '../constants';
import { TUser } from '../types';
import { getCookies } from '../utils';
import { create } from 'zustand';

type State = {
  isAuthenticated: boolean;
  clientId: string | null;
  user?: TUser;
  mgmChannelId?: string;
};

type Actions = {
  setIsAuthenticated: (value: boolean) => void;
  setClientId: (value: string) => void;
  setUser: (user: TUser) => void;
  removeUser: () => void;
  setMgmChannelId: (id: string) => void;
};

// Load user from localStorage if available
const loadUserFromStorage = (): TUser | undefined => {
  try {
    const userStr = localStorage.getItem('user_data');
    if (userStr) {
      return JSON.parse(userStr);
    }
  } catch (e) {
    console.error('Failed to load user from localStorage:', e);
  }
  return undefined;
};

const useUserStore = create<State & Actions>((set) => ({
  isAuthenticated: !!localStorage.getItem(storageKeys.ACCESS_TOKEN),
  clientId:
    getCookies(COOKIE_KEYS.CLIENT_ID) ||
    localStorage.getItem(storageKeys.CLIENT_ID),
  user: loadUserFromStorage(),
  mgmChannelId: localStorage.getItem('mgm_channel_id') || undefined,
  setIsAuthenticated: (value: boolean) =>
    set(() => ({ isAuthenticated: value })),
  setClientId: (value: string) => set(() => ({ clientId: value })),
  setUser: (user: TUser) => {
    // Save user to localStorage
    if (user) {
      localStorage.setItem('user_data', JSON.stringify(user));
    } else {
      localStorage.removeItem('user_data');
    }
    set(() => ({ user: user }));
  },
  removeUser: () => {
    localStorage.removeItem('user_data');
    set(() => ({ user: undefined }));
  },
  setMgmChannelId: (channelId) => {
    if (channelId) {
      localStorage.setItem('mgm_channel_id', channelId);
    } else {
      localStorage.removeItem('mgm_channel_id');
    }
    set(() => ({ mgmChannelId: channelId }));
  },
}));

export default useUserStore;
